const EMPTY_TYPE_STRING = '-'

export const encodeAndCopyToClipboard = (
  data: object | unknown[],
  type?: string
): Promise<void> => {
  const str = `octopus:${type || EMPTY_TYPE_STRING}:buffer:${btoa(
    encodeURIComponent(JSON.stringify(data))
  )}`

  return navigator.clipboard.writeText(str).catch((err) => {
    console.error('Problem with writing to clipboard', err)
  })
}

const convertStringToObject = (clipboardText: string) => {
  const match = clipboardText.match(/octopus:([^:]+):buffer:(.+)/)

  if (!match) {
    return
  }

  const [_, matchType, encodedData] = match
  const type = matchType === EMPTY_TYPE_STRING ? null : matchType
  return {
    type,
    value: JSON.parse(decodeURIComponent(atob(encodedData))),
  }
}

export const decodeFromClipboard = async (): Promise<
  | {
      type: string | null
      value: unknown
    }
  | undefined
> => {
  const clipboardText = await navigator.clipboard.readText()

  return convertStringToObject(clipboardText)
}

const checkBufferSync = (text: string) => {
  const decodedBufferData = convertStringToObject(text)

  if (
    decodedBufferData?.type === 'node' ||
    decodedBufferData?.type === 'node+arrow' ||
    decodedBufferData?.type === 'copyable_store'
  ) {
    return 'node'
  }

  if (decodedBufferData?.type === 'block') {
    return 'block'
  }

  if (decodedBufferData?.type === 'stickyNote') {
    return 'stickyNote'
  }
}

export const setPreventPast = (text: string) => {
  const copiedType = checkBufferSync(text)

  if (copiedType === 'node' || copiedType === 'block') {
    return true
  }

  if (
    copiedType === 'stickyNote' ||
    copiedType === 'node' ||
    copiedType === 'block'
  ) {
    return true
  }
}
